module.exports = __webpack_public_path__ + "img/select-reward-ilustra.eb1b0d9b.png";